// extracted by mini-css-extract-plugin
module.exports = {"container":"AdHocForwardDating_container__2_7wa","text":"AdHocForwardDating_text__2bOV9"};